'use client';

import { c as _c } from "react/compiler-runtime";
import { Switch } from '@repo/ui';
import { type ReactNode, use } from 'react';
import type { MasterFilterState } from './types';
import { FilterRow } from './FilterRow';
import { MasterFilterContext } from './MasterFilter';
export interface MasterFilterToggleProps<TState extends MasterFilterState = MasterFilterState> {
  name: Extract<keyof TState, string>;
  label: ReactNode;
  tooltip?: string;
  className?: string;
}
export function MasterFilterToggle(t0) {
  const $ = _c(12);
  const {
    name,
    label,
    tooltip,
    className
  } = t0;
  const context = use(MasterFilterContext);
  if (!context) {
    throw new Error("MasterFilter.Toggle must be used within a MasterFilter.Provider");
  }
  const {
    state,
    actions
  } = context;
  const checked = typeof state[name] === "boolean" ? state[name] : false;
  let t1;
  if ($[0] !== actions || $[1] !== checked || $[2] !== name) {
    t1 = () => {
      actions.updateField(name, !checked);
    };
    $[0] = actions;
    $[1] = checked;
    $[2] = name;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleToggle = t1;
  let t2;
  if ($[4] !== checked || $[5] !== handleToggle) {
    t2 = <Switch checked={checked} onCheckedChange={handleToggle} />;
    $[4] = checked;
    $[5] = handleToggle;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== className || $[8] !== label || $[9] !== t2 || $[10] !== tooltip) {
    t3 = <FilterRow label={label} tooltip={tooltip} className={className}>{t2}</FilterRow>;
    $[7] = className;
    $[8] = label;
    $[9] = t2;
    $[10] = tooltip;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}
MasterFilterToggle.displayName = 'MasterFilterToggle';